// Services
import { HttpService } from "@mgs/ci2019-common/src/services/HttpService";

// Store
import { Store } from "#/store";

// Model
import { FilterDataResponse } from "#/common/interfaces/kpi/FilterDataResponse";
import { FilterDataByCountryResponse } from "../common/interfaces/kpi/FilterDataByCountryResponse";
import {
  FilterHistoricalDataResponse,
  IHistoricalData,
} from "../common/interfaces/kpi/FilterHistoricalDataResponse";

export class KpiService {
  private static _instance;

  public static get instance() {
    if (!this._instance) {
      this._instance = new KpiService();
    }
    return this._instance;
  }

  private constructor() {}

  private readonly http: HttpService = HttpService.instance;

  public async getFilterData(filterId: number): Promise<FilterDataResponse> {
    let queryUrl = Store.instance.ui.kpiApiUrl + `/public/filters/${filterId}`;
    const response = await this.http.get<FilterDataResponse>(queryUrl);

    return response.body!;
  }

  public async getFilterDataByCountry(
    filterId: number
  ): Promise<FilterDataByCountryResponse> {
    let queryUrl =
      Store.instance.ui.kpiApiUrl + `/public/filters/${filterId}/by/country`;
    const response = await this.http.get<FilterDataByCountryResponse>(queryUrl);

    return response.body!;
  }

  public async getFilterHistoricalData({
    filterId,
    interval,
    length,
    dayOfWeek,
    dayOfMonth,
    month,
  }: IHistoricalData): Promise<FilterHistoricalDataResponse[]> {
    const params = { dayOfWeek, dayOfMonth, month };
    let queryUrl =
      Store.instance.ui.kpiApiUrl +
      `/public/filters/${filterId}/historicalData/${interval}/${length}`;
    const response = await this.http.get<FilterHistoricalDataResponse[]>(
      queryUrl,
      { params }
    );

    return response.body!;
  }
}
